import styled from 'styled-components/macro';

export const Emphasis = styled.span`
  font-weight: 600;
`;
